import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export default function NewsTicker() {
  const { data } = useQuery({
    queryKey: ["breaking"],
    queryFn: () => api.get("/articles/breaking").then((r) => r.data),
  });

  const items = data || [];
  if (items.length === 0) return null;

  const loop = [...items, ...items];

  return (
    <div
      className="border-b border-slate-800 bg-slate-900 text-white"
      data-testid="news-ticker"
    >
      <div className="mx-auto flex max-w-7xl items-center px-4 sm:px-6 lg:px-8">
        <span className="z-10 mr-4 hidden shrink-0 items-center gap-2 bg-red-600 px-3 py-2 text-xs font-bold uppercase tracking-wider sm:inline-flex">
          <span className="h-2 w-2 animate-pulse rounded-full bg-white" />
          Извънредно
        </span>
        <div className="ticker-wrap relative flex-1 overflow-hidden py-2">
          <div className="ticker-track">
            {loop.map((it, i) => (
              <Link
                key={`${it.id}-${i}`}
                to={`/article/${it.slug}`}
                className="mx-6 text-sm font-medium text-slate-200 transition-colors hover:text-white"
              >
                <span className="mr-2 text-primary">●</span>
                {it.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
